import { TextField as SerendieTextField } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX, RefObject, createRef } from "react";
import "./Styles.scss";
import React from "react";

export class TextField extends BaseComponent<ITextFieldProps, ITextFieldState>
{
    public static requiredLabel?: string;

    public render(): JSX.Element
    {
        return <SerendieTextField
            {...this.props}
            autoComplete={this.props.autoComplete || 'one-time-code'}
            className={`${this.props.className ?? ''} serendie-textfield`}
            requiredLabel={this.props.requiredLabel ?? TextField.requiredLabel}
        />
    }
}

export interface ITextFieldProps extends React.ComponentProps<typeof SerendieTextField> { }

export interface ITextFieldState { }
